<template>
  <div class="flex flex-col @4xl:flex-row gap-6">
    <div v-if="$slots.leftSidebar" class="hidden @4xl:w-80 @container @6xl:flex flex-col gap-6">
      <slot name="leftSidebar" />
    </div>

    <div class="flex-1 @container flex flex-col gap-12">
      <slot />
    </div>

    <div
      v-if="$slots.leftSidebar || $slots.sidebar"
      class="@4xl:w-80 flex flex-col gap-6"
      :class="{ '@6xl:hidden': !$slots.sidebar }">
      <div v-if="$slots.leftSidebar" class="@container flex @6xl:hidden flex-col gap-6">
        <slot name="leftSidebar" />
      </div>
      <div v-if="$slots.sidebar" class="@container flex flex-col gap-6">
        <slot name="sidebar" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mobileFlip: {
      type: Boolean,
      default: false
    }
  }
}
</script>
